export default {"src":"/_next/static/media/business.1fc98b77.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};